import React from 'react';

import MobileHome from '../../components/responsive/mobileHome';
import ScanLocation from '../../components/responsive/scanLocation';
import PickListScanLocation from '../../components/responsive/scanNewLocation';
import ScanNewLocation from '../../components/responsive/scanNewLocationt';
import LocationDetails from '../../components/responsive/locationDetails';
import LocationDetailsAdd from '../../components/responsive/locationDetailsAdd';
import ListLocations from '../../components/responsive/listLocations';
import ScanAddProduct from '../../components/responsive/scanAddProduct.js';
import ScanTransferProduct from '../../components/responsive/scanTransferProduct';
import ChooseOldLocation from '../../components/responsive/chooseOldLocation';
import PickList from '../../components/responsive/pickList';
import ScanPickProduct from '../../components/responsive/scanPickProduct';
import Locations from "../../containers/warehouse-location/userLocationItems"
import WarehouseLocation from "../../containers/warehouse-location/index"
import LocationActions from '../../containers/warehouse-location/showLocationActions';
import LocationName from "../../containers/warehouse-location/location-name"
import Sku from '../../containers/inventory/Sku.js';
import Products from '../../containers/inventory/Products.js';
import VendorItems from '../../containers/inventory/VendorItems.js';
import PoHistory from '../../containers/purchase-order/po-history/index.js';
import PoDetails from '../../containers/purchase-order/po-details/index.js';
import PoWarehouse from '../../containers/purchase-order/po-warehouse/index.js';
import PoWarehouseDetails from '../../containers/purchase-order/po-warehouse-details/index.js';
import PosMobile from '../../containers/mobileScreens/PoScreens/PoHistoryMobile';
import PoDetailsMobile from '../../containers/mobileScreens/PoScreens/PoDetailsMobile';
import ClientOrders from '../../containers/logistics/orders/client/index.js';
import CreateInventoryWorkOrder from '../../containers/inventory/create-work-order/index.js';
import WareHouseWorkOrder from '../../containers/logistics/orders/warehouse/index.js';
import PlacementOption from '../../containers/inventory/create-work-order/inbound-plan/placement-option/index.js';
import ConfirmPlacement from '../../containers/inventory/create-work-order/inbound-plan/confirm-placement/index.js';
import Shipping from '../../containers/logistics/orders/warehouse/shipping/index.js';
import Dashboard from '../../containers/dashbaord';
import FileUploadHistory from '../../containers/file-upload/index.js';
import Billing from '../../containers/billing/index.js';

export const STORAGE_ROUTES = [
  {
    path: '/home',
    component: <MobileHome />,
    group: 'MobileStorage'
  },
  {
    path: '/scan-location',
    component: <ScanLocation />,
    group: 'MobileStorage'
  },
  {
    path: '/scan-new-location',
    component: <ScanNewLocation />,
    group: 'MobileStorage'
  },
  {
    path: '/scan-pick-location',
    component: <PickListScanLocation />,
    group: 'MobileStorage'
  },
  {
    path: '/location-details',
    component: <LocationDetails />,
    group: 'MobileStorage'
  },
  {
    path: '/location-details-add',
    component: <LocationDetailsAdd />,
    group: 'MobileStorage'
  },
  {
    path: '/pick-list-locations',
    component: <ListLocations />,
    group: 'MobileStorage'
  },
  {
    path: '/scan-add-products',
    component: <ScanAddProduct />,
    group: 'MobileStorage'
  },
  {
    path: '/scan-transfer-products',
    component: <ScanTransferProduct />,
    group: 'MobileStorage'
  },
  {
    path: '/choose-old-location',
    component: <ChooseOldLocation />,
    group: 'MobileStorage'
  },
  {
    path: '/pick-list',
    component: <PickList />,
    group: 'MobileStorage'
  },
  {
    path: '/scan-pick-products',
    component: <ScanPickProduct />,
    group: 'MobileStorage'
  },
  {
    path: '/warehouse-location',
    component: <WarehouseLocation />,
    group: 'Storage',
    permission: 'location'
  },
  {
    path: '/inventory/sku',
    component: <Sku />,
    group: 'ThreeLayerInventory',
    permission: 'inventory'
  },
  {
    path: '/inventory/work-order/:workOrderId',
    component: <CreateInventoryWorkOrder />,
    group: 'ThreeLayerInventory',
    permission: 'logistics'
  },
  {
    path: '/inventory/products',
    component: <Products />,
    group: 'ThreeLayerInventory',
    permission: 'inventory'
  },
  {
    path: '/inventory/vendor',
    component: <VendorItems />,
    group: 'ThreeLayerInventory',
    permission: 'inventory'
  },
  {
    path: '/locations',
    component: <Locations />,
    group: 'InternalStorage',
    permission: 'location'
  },
  {
    path: '/location-names',
    component: <LocationName />,
    group: 'Storage',
    permission: 'location'
  },
  {
    path: '/locations-history',
    component: <LocationActions />,
    group: 'Storage',
    permission: 'location'
  },
  {
    path: '/file-upload-history',
    component: <FileUploadHistory />,
    group: 'ThreeLayerInventory',
    permission: 'fileHistory'
  },
  {
    path: '/billing',
    component: <Billing />,
    group: 'ThreeLayerInventory'
  },
  {
    path: '/po-history',
    component: <PoHistory />,
    group: 'ThreeLayerInventory',
    permission: 'purchasing'
  },
  {
    path: '/po-details/:poId',
    component: <PoDetails />,
    group: 'ThreeLayerInventory',
    permission: 'purchasing'
  },
  {
    path: '/po-warehouse',
    component: <PoWarehouse />,
    group: 'WarehousePos',
    permission: 'purchasing'
  },
  {
    path: '/po-warehouse-details/:id',
    component: <PoWarehouseDetails />,
    group: 'ReceivingMobile',
    permission: 'purchasing'
  },
  {
    path: '/po-mobile',
    component: <PosMobile />,
    group: 'ReceivingMobile',
    permission: 'purchasing'
  },
  {
    path: '/po-details-mobile/:id',
    component: <PoDetailsMobile />,
    group: 'ReceivingMobile',
    permission: 'purchasing'
  },
  {
    path: '/work-orders',
    component: <ClientOrders />,
    group: 'WorkOrder',
    permission: 'logistics'
  },
  {
    path: '/placement-option/:workOrderId',
    component: <PlacementOption />,
    group: 'WorkOrder',
    permission: 'logistics'
  },
  {
    path: '/confirm-placement/:workOrderId',
    component: <ConfirmPlacement />,
    group: 'WorkOrder',
    permission: 'logistics'
  },
  {
    path: '/warehouse-work-orders',
    component: <WareHouseWorkOrder />,
    group: 'WorkOrder',
    permission: 'logistics'
  },
  {
    path: '/shipping/:workOrderId',
    component: <Shipping />,
    group: 'WorkOrder',
    permission: 'logistics'
  },
  {
    path: '/dashboard',
    component: <Dashboard />,
    group: 'Dashboard',
    permission: 'dashboard'
  },
];
